import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogOverlay,
  Box,
  Button,
  ButtonGroup,
  Flex,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import { FaArrowRight } from "react-icons/fa";
import { BILLING_PLANS, REGISTER_PATH, ROOT } from "../../_utils/routes";
import TldrVideoInAction from "../../TldrAi/TldrVideoInAction";
import { useSelector } from "react-redux";

const FeatureLockModal = ({
  cancelButtonText,
  confirmButtonText,
  loading,
  image,
  onCancel,
  onConfirm,
  children,
  video,
  isSignupView,
}) => {
  const { t } = useTranslation(["common"]);
  const history = useHistory();
  const isMobileView = useSelector((state) => state.app.isMobileView);

  const handleRedirectToBilling = useCallback(() => {
    history.push(BILLING_PLANS);
  }, [history]);

  return (
    <AlertDialog autoFocus={false} isOpen onClose={onCancel} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent
          minWidth={["0", "0", "0", "768px"]}
          borderRadius="lg"
          overflow="hidden"
          _before={{
            content: '""',
            position: "absolute",
            zIndex: 0,
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background:
              "radial-gradient(50% 50% at 50% 50%, #13303E 0%, rgba(30, 30, 30, 0) 100%);",
          }}
        >
          {onCancel && <AlertDialogCloseButton zIndex="2" />}
          <AlertDialogBody position="relative" zIndex="1" p="0">
            <Flex direction={["column", "column", "column", "row"]}>
              <Flex
                justifyContent="center"
                alignItems="center"
                width={["100%", "100%", "100%", "330px"]}
                position="relative"
                minHeight={["32"]}
              >
                {video && (
                  <Box
                    position="relative"
                    width="100%"
                    zIndex="2"
                    textAlign="center"
                  >
                    <TldrVideoInAction videoInAction={video} showPlayIcon />
                  </Box>
                )}
                <Image
                  src={image}
                  alt=""
                  role="presentation"
                  position="absolute"
                  width="100%"
                  height="100%"
                  objectFit="cover"
                  zIndex="1"
                  top="0"
                />
              </Flex>
              <Flex flex="1" minH="500px">
                <Box>
                  <Box
                    px="10"
                    pt="6"
                    pb="6"
                    h={isMobileView ? "528px" : "428px"}
                    display={"flex"}
                    flexDir="column"
                    justifyContent="center"
                  >
                    {children}
                  </Box>

                  <Box p={4}>
                    {isSignupView ? (
                      <ButtonGroup
                        spacing="3"
                        // mt="4"
                        justifyContent="flex-end"
                        w="full"
                      >
                        <Button
                          as={Link}
                          href={ROOT}
                          target="_blank"
                          variant="ghost"
                          _hover={{
                            textDecoration: "none",
                            background: "whiteAlpha.200",
                          }}
                        >
                          {t("have_account",{ns:"tools"})}
                          <Text color="brand.primary" ml={1}>
                            {t("errors.sign_in", { ns: "common" })}
                          </Text>
                        </Button>
                        <Button
                          href={REGISTER_PATH}
                          target="_blank"
                          as={Link}
                          className="tool_link_btn"
                          variant="solid"
                          rightIcon={<FaArrowRight />}
                        >
                          {t("signup_btn",{ns:"tools"})}
                        </Button>
                      </ButtonGroup>
                    ) : (
                      <ButtonGroup
                        spacing="3"
                        // mt="4"
                        justifyContent="flex-end"
                        w="full"
                      >
                        {onCancel && (
                          <Button onClick={onCancel} variant="ghost">
                            {cancelButtonText || t("maybe_later")}
                          </Button>
                        )}
                        {onConfirm && (
                          <Button
                            onClick={
                              onConfirm ? onConfirm : handleRedirectToBilling
                            }
                            variant="solid"
                            isLoading={loading}
                            rightIcon={<FaArrowRight />}
                          >
                            {confirmButtonText || t("choose_plan")}
                          </Button>
                        )}
                      </ButtonGroup>
                    )}
                  </Box>
                </Box>
              </Flex>
            </Flex>
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

FeatureLockModal.propTypes = {
  children: PropTypes.node,
  cancelButtonText: PropTypes.string,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  video: PropTypes.string,
  image: PropTypes.string.isRequired,
};

FeatureLockModal.defaultProps = {
  children: undefined,
  cancelButtonText: undefined,
  confirmButtonText: undefined,
  isOpen: undefined,
  loading: false,
  video: undefined,
  image: undefined,
};

export default FeatureLockModal;
